import Question from "./Question";
import Answer from "./Answer";
import QuestionList from "./QuestionList";

window.jQuery = window.$ = require('jquery');

(function( $, window, document, undefined ){
    require('jquery-ui/ui/widget');

    $.widget( "pureStrategies.assessment", {

        options: {
            questionList: null,
            previousLinkEl: '.previous',
            nextLinkEl: '.next',
            resetLinkEl: '.reset',
            questionEl: '.question',
            questionTextEl: '.text',
            answerEl: '.answer',
            answerFilter: null
        },

        _create: function() {
            if ($(this.options.previousLinkEl).length > 0) {
                this.element.on('click', this.options.previousLinkEl, (e) => {
                    this.previous();
                });
            }

            if ($(this.options.nextLinkEl).length > 0) {
                this.element.on('click', this.options.nextLinkEl, (e) => {
                    this.next();
                });
            }

            if ($(this.options.resetLinkEl).length > 0) {
                this.element.on('click', this.options.resetLinkEl, (e) => {
                    e.preventDefault();
                    this.reset();
                });
            }

            this.reset();
        },
        _buildQuestionListFromDom() {
            const self = this;
            this.options.questionList = new QuestionList(self.options.answerFilter);
            const $questions = self.element.find(self.options.questionEl);

            $questions.each(function() {
                const questionId = $(this).data('id');
                const questionText = $(this).find(self.options.questionTextEl).text();
                const $answers = $(this).find(self.options.answerEl);
                const $question = $(this);
                const question = new Question(questionId, questionText);

                $answers.each(function() {
                    const answerId = $(this).data('id');
                    const answerText = $(this).find('label').text();
                    const answer = new Answer(answerId, answerText);
                    question.addAnswer(answer);

                    $(this).find(':checkbox').on('change', function(e) {
                        const name = $(this).attr('name');
                        const values = $question.find(`:checkbox[name="${name}"]:checked`).map(function(_, v) {
                            return $(v).val();
                        }).get();

                        self.setResults(values, questionId);
                    });

                    $(this).find(':radio').on('change', function(e) {
                        self.setResults($(this).val(), questionId);
                    });
                });

                self.options.questionList.push(question);
            });
        },
        reset: function(forceRebuildDom = false) {
            if (forceRebuildDom || this.options.questionList === null) {
                this.options.questionList = null;
                this._buildQuestionListFromDom();
            }

            this.options.questionList.clearAllResults();
            this.currentQuestion = this.options.questionList.getNodeAtIndex(0);
            this.element.trigger('navigated.beginning', [this.currentQuestion]);
            return this;
        },
        next: function() {
            const nextQuestion = this.currentQuestion.getNext();
            if (nextQuestion === null) {
                return this;
            }

            this.currentQuestion = nextQuestion;
            if (this.currentQuestion.getNext() === null) {
                this.element.trigger('navigated.last', [this.currentQuestion]);
            } else {
                this.element.trigger('navigated.forward', [this.currentQuestion]);
            }
            return this;
        },
        previous: function() {
            const previousQuestion = this.currentQuestion.getPrevious();
            if (previousQuestion === null) {
                return this;
            }

            this.currentQuestion = previousQuestion;
            if (this.currentQuestion.getPrevious() === null) {
                this.element.trigger('navigated.beginning', [this.currentQuestion]);
            } else {
                this.element.trigger('navigated.backward', [this.currentQuestion]);
            }
            return this;
        },
        getCurrentQuestion: function() {
            return this.currentQuestion;
        },
        setResults: function(ids, questionId = null) {
            if (questionId === null) {
                this.currentQuestion.setResults(ids);
                this.element.trigger('setResults', [this.currentQuestion, ids]);
            } else {
                const question = this.options.questionList.getNodeByQuestionId(questionId);
                question.setResults(ids);
                this.element.trigger('setResults', [question, ids]);
            }
            return this;
        },
        getResults: function() {
            return this.options.questionList.getAllResults();
        },
        getQuestionList: function() {
            return this.options.questionList;
        }

    });

})( jQuery, window , document );